export default `
/*
  Warnings:

  - You are about to drop the column \`email\` on the \`User\` table. All the data in the column will be lost.

*/
-- RedefineTables
PRAGMA defer_foreign_keys=ON;
PRAGMA foreign_keys=OFF;
CREATE TABLE "new_User" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "user_auth_id" TEXT,
    "name" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "updated_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP
);
INSERT INTO "new_User" ("created_at", "id", "name", "updated_at", "user_auth_id") SELECT "created_at", "id", "name", "updated_at", "user_auth_id" FROM "User";
DROP TABLE "User";
ALTER TABLE "new_User" RENAME TO "User";
CREATE UNIQUE INDEX "User_user_auth_id_key" ON "User"("user_auth_id");
CREATE INDEX "User_created_at_idx" ON "User"("created_at");
CREATE INDEX "User_updated_at_idx" ON "User"("updated_at");
PRAGMA foreign_keys=ON;
PRAGMA defer_foreign_keys=OFF;
`;
